import { ScrollTrigger } from './scroll-trigger';

export function init() {
	let element = document.querySelector('.js-curtains');

	if (!element) {
		return;
	}

	let left = element.querySelector('.js-curtain-left');
	let right = element.querySelector('.js-curtain-right');
	let content = element.querySelector('.js-curtain-content');

	if (!(left && right && content)) {
		return;
	}

	calcTransform();

	ScrollTrigger(element, {
		onUpdate,
		start: '0 0.5',
	});

	function onUpdate(entry) {
		if (!entry.isVisible) {
			return;
		}

		left.style.transform = '';
		right.style.transform = '';
	}

	function calcTransform() {
		let contentWidth = content.clientWidth;

		left.style.transform = `translateX(${contentWidth * 0.9}px)`;
		right.style.transform = `translateX(${-contentWidth * 0.9}px)`;
	}
}
